import _ from 'lodash';
import { routes as navigation } from '../../components/navigation.vue';
import * as types from '../mutation-types';
import api from '../../helpers/api';


const defaultConfig = {
  updateInterval: 15,
  navigation,
};

export default {
  state: {
    config: {},
    device: {},
  },
  getters: {
    getConfig: (state) => state.config,
    getDevice: (state) => state.device,
  },
  actions: {
    async getConfig({ commit }) {
      let config = await api.get(`devices/${window.machineId}/config`);
      config = await _.merge({}, defaultConfig, config);
      commit(types.RECEIVED_DEVICE_CONFIG, { config });
    },
  },
  mutations: {
    [types.RECEIVED_DEVICE](state, { device }) {
      state.device = device;
    },
    [types.RECEIVED_DEVICE_CONFIG](state, { config }) {
      api.setToken(config.apikey);
      state.config = config;
    },
  },
};
